import { isInApp, actBindAliYunPush, actSetUdSpUtil, actCheckNotification } from '@g/utils/appSDK'
import dayjs from 'dayjs'
import * as storageUtils from '@g/utils/storageUtils'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  init ({ state, commit, dispatch, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/user-prepare/init', {
      params,
      noShowError: true
    }).then(res => {
      if (res.data.model) {
        if (isInApp()) {
          actBindAliYunPush(res.data.model.user?.uid)
          actSetUdSpUtil('accessToken', encodeURIComponent(localStorage.accessToken))
          actSetUdSpUtil('uid', res.data.model.user?.uid)
          actCheckNotification().then((v) => {
            dispatch('user/userdevice/update', {
              udPush: v,
            }, {
              root: true
            })
          })
        }
        window.ga && window.ga('set', 'userId', res.data.model.user?.uid)
      }
      return res
    })
  },
  home ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/user-prepare/home', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
